// extracted by mini-css-extract-plugin
export default {"navLink":"Header_navLink_KWaDE","add-nav-padding-left":"Header_add-nav-padding-left_WVtL_","spinAround":"Header_spinAround_RtEOL"};